// components/EventFooter.js
import React from "react"
import footer from "../../assets/images/footer.png"
function EventFooter() {
    return (
        <div className="event-footer">
            <img src={footer} />
        </div>
    )
}

export default EventFooter
